{
    "common": {
        "or": "oder",
        "logo_alt": "Logo",
        "loading": "Wird geladen",
        "internet_restored": "Internetverbindung wiederhergestellt",
        "internet_lost": "Internetverbindung unterbrochen",
        "new_version_available": "Eine neue Version der Anwendung ist verfügbar. Die App wird in 10 Sekunden aktualisiert.",
        "app_updated": "Anwendung auf die neueste Version aktualisiert."
    },
    "login": {
        "welcome": "Wie möchten Sie sich anmelden?",
        "no_account": "Neu bei Medendo?",
        "start_trial_link": "Starten Sie Ihre kostenlose Testphase",
        "finish_setup_message": "Ihr Konto ist bereit. Melden Sie sich an, um die Zwei-Faktor-Authentifizierung einzurichten.",
        "email_step": {
            "email_label": "E-Mail-Adresse eingeben",
            "next_button": "Weiter",
            "invalid_email": "Ungültige E-Mail-Adresse"
        },
        "refer_to_email_step": {
            "message": "Eine E-Mail wurde gesendet an: <1>{{email}}</1><2/><3/>Folgen Sie den Anweisungen in Ihrer E-Mail<4/>Sie können dieses Fenster schließen."
        },
        "mfa_step": {
            "title": "Verifizierungscode eingeben",
            "code_label": "Verifizierungscode",
            "verify_button": "Verifizieren",
            "no_code_button": "Ich finde den Code nicht",
            "error_expired": "Der Code ist abgelaufen. Bitte versuchen Sie es erneut.",
            "error_incorrect": "Der Code ist falsch. Bitte versuchen Sie es erneut."
        },
        "mfa_setup_step": {
            "title": "Einrichtung der Multi-Faktor-Authentifizierung",
            "setup_error": "Bei der Einrichtung von TOTP ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
            "verification_error": "Der Verifizierungscode ist falsch. Bitte versuchen Sie es erneut.",
            "finalize_error": "Die Verifizierung war erfolgreich, aber die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
            "scan_instruction": "Scannen Sie diesen QR-Code mit Ihrer Authenticator-App:",
            "manual_entry_instruction": "Oder geben Sie den Code unten manuell ein:",
            "code_input_instruction": "Geben Sie den Verifizierungscode ein:",
            "code_label": "Verifizierungscode",
            "verify_button": "Verifizieren"
        },
        "password_step": {
            "title": "Passwort",
            "password_label": "Passwort eingeben",
            "login_button": "Anmelden",
            "forgot_password_button": "Passwort vergessen?",
            "error_invalid_password": "Ungültiges Passwort. Bitte versuchen Sie es erneut.",
            "error_mfa_verify": "Bei der Verifizierung Ihres Kontos ist ein Fehler aufgetreten.",
            "error_send_email": "Beim Senden der E-Mail ist ein Fehler aufgetreten.",
            "error_send_reset_email": "Fehler beim Senden der E-Mail",
            "reset_email_sent": "Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet.",
            "sso_hint": "Ihr Konto verwendet die Anmeldung über Google oder Microsoft. Passwort-Anmeldung und Passwort-Wiederherstellung sind nicht verfügbar.",
            "welcome_verify_email": "Willkommen bei Medendo! 🚀 Wir senden Ihnen zunächst eine <strong>E-Mail</strong>, damit Sie Ihr eigenes Passwort festlegen können.",
            "send_email_button": "E-Mail senden"
        }
    },
    "account_disabled": {
        "title": "Ihr Konto wurde deaktiviert",
        "message": "Sie haben keinen Zugriff mehr auf Medendo.\nWenn Sie denken, dass das ein Fehler ist, wenden Sie sich bitte an Ihren Systemadministrator beziehungsweise an die Person, die Medendo bei Ihnen eingerichtet hat.",
        "logout_button": "Abmelden"
    },
    "signup": {
        "title": "Erstellen Sie Ihr Konto",
        "subtitle": "Starten Sie Ihre kostenlose Testphase bei Medendo",
        "email_label": "E-Mail-Adresse eingeben",
        "password_label": "Passwort wählen",
        "invalid_email": "Ungültige E-Mail-Adresse",
        "weak_password": "Das Passwort muss mindestens {{min}} Zeichen lang sein",
        "password_hint": "Mindestens {{min}} Zeichen",
        "send_code_button": "Verifizierungscode senden",
        "code_sent": "Wir haben einen 6-stelligen Code an {{email}} gesendet. Geben Sie ihn unten ein.",
        "redirecting_to_checkout": "E-Mail bestätigt, Sie werden zur Kasse weitergeleitet...",
        "completing": "Ihr Konto wird fertiggestellt...",
        "complete_expired": "Dieser Checkout-Link ist abgelaufen oder wurde nicht abgeschlossen. Bitte beginnen Sie erneut.",
        "code_label": "Verifizierungscode",
        "verify_code_button": "Verifizieren",
        "invalid_code": "Der Code ist falsch oder abgelaufen",
        "resend_code": "Code erneut senden",
        "resend_cooldown": "Erneut senden in {{seconds}}s",
        "wrong_email": "Falsche E-Mail-Adresse? Von vorn beginnen",
        "email_verified": "{{email}} ist verifiziert - vervollständigen Sie jetzt Ihr Konto",
        "create_button": "Konto erstellen",
        "account_exists": "Sie haben bereits ein Konto mit dieser E-Mail-Adresse. Melden Sie sich stattdessen an.",
        "already_completed": "Ihr Konto ist bereits eingerichtet. Melden Sie sich stattdessen an.",
        "unavailable": "Anmeldung ist gerade nicht verfügbar. Schauen Sie bald wieder vorbei.",
        "have_account": "Haben Sie schon ein Konto?",
        "go_to_login": "Anmelden",
        "error_generic": "Bei der Registrierung ist etwas schiefgelaufen. Bitte versuchen Sie es erneut.",
        "checkout_cancelled": "Der Bezahlvorgang wurde abgebrochen. Sie können es jederzeit erneut versuchen.",
        "rate_limited": "Zu viele Versuche. Warten Sie einen Moment und versuchen Sie es erneut.",
        "retry_button": "Erneut versuchen",
        "first_name_label": "Vorname",
        "last_name_label": "Nachname",
        "name_required": "Geben Sie Ihren Vor- und Nachnamen ein",
        "toggle_password_visibility": "Passwort anzeigen oder verbergen",
        "trial_started": "Ihr Testzeitraum hat begonnen.",
        "continue_button": "Weiter"
    },
    "encounter": {
        "offline_too_long": "Zu lange offline, Aufnahme gestoppt. Klicken Sie auf die Schaltfläche \"Neu generieren\", um einen Bericht zu erstellen.",
        "undo": "Rückgängig",
        "redo": "Wiederholen",
        "name": "Name",
        "menu_record": "Neue Aufnahme",
        "menu_history": "Verlauf",
        "menu_templates": "Vorlagen",
        "menu_admin": "Admin",
        "menu_settings": "Einstellungen",
        "menu_open": "Menü",
        "menu_close": "Menü schließen",
        "menu_integrations": "Integrationen",
        "menu_support": "Support",
        "report": "Bericht",
        "report_field_empty": "Nichts erfasst",
        "transcript_empty_title": "Noch kein Transkript",
        "transcript_empty_body": "Starten Sie die Aufnahme, dann erscheint das Gespräch hier, während Sie sprechen",
        "report_empty_title": "Noch kein Bericht",
        "report_empty_body": "Beenden Sie die Aufnahme, dann wird der Bericht aus dem Gespräch erstellt",
        "report_empty_body_no_permission": "Mit Ihrem Konto können Sie hier keine Berichte erstellen",
        "report_generating_body": "Der Bericht wird aus dem Gespräch erstellt…",
        "transcript": "Transkript",
        "template": "Vorlage",
        "logout": "Abmelden",
        "logout_confirm_title": "Abmelden?",
        "logout_confirm_body": "Sie werden auf diesem Gerät abgemeldet und zum Anmeldebildschirm zurückgeleitet.",
        "logout_confirm": "Abmelden",
        "customer_portal": "Zum Kundenportal",
        "customer_portal_error": "Beim Öffnen des Kundenportals ist etwas schiefgelaufen. Bitte versuchen Sie es erneut.",
        "conversation_not_available": "Dieses Gespräch ist nicht mehr verfügbar.",
        "loading": "Laden...",
        "select_patient": "Klient auswählen",
        "client_locked_by_assistant": "Diese Aufnahme ist mit {{name}} verknüpft. Um mit einem anderen Klienten zu arbeiten, starten Sie eine neue Aufnahme.",
        "client_locked_by_assistant_unnamed": "Diese Aufnahme ist mit einem Klienten verknüpft. Um mit einem anderen Klienten zu arbeiten, starten Sie eine neue Aufnahme.",
        "switch_to_patient_search": "Zur Klientensuche wechseln",
        "no_patients_found": "Keine Klienten gefunden",
        "no_patient": "Kein Klient - Namen eingeben",
        "patient_id_duplicate_hint": "Die Klienten-ID wird angezeigt, wenn Name und Geburtsdatum nicht eindeutig sind.",
        "no_templates_message": "Sie benötigen eine Vorlage, um ein Gespräch zu starten",
        "no_templates_subtitle": "Wählen Sie oben eine aus oder richten Sie eine unter Vorlagen ein.",
        "no_templates_action": "Zu den Vorlagen",
        "no_care_plan_templates": "Keine Vorlagen für diesen Klienten verfügbar",
        "care_plan_templates_load_error": "Die Vorlagen für diesen Klienten konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
        "care_plan_template_resolve_error": "Die ausgewählte Vorlage konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
        "in_person": "Persönlich",
        "online": "Online",
        "meeting_type": "Gesprächsart",
        "start": "Aufnahme starten",
        "stop": "Aufnahme stoppen",
        "recording": "Aufnahme...",
        "resume": "Fortsetzen",
        "leave_while_recording_title": "Aufnahme läuft",
        "leave_while_recording": "Sie nehmen noch auf. Möchten Sie diese Seite verlassen und die Aufnahme beenden?",
        "sticky_panel": "Schwebendes Aufnahmepanel",
        "copied": "Kopiert",
        "unknown": "unbekannt",
        "submit_confirmation_title": "Übermittlung bestätigen",
        "submit_confirmation_content": "Dieser Bericht wird an \"{{adapter}}\"{{patientName}} gesendet. Sind Sie sicher?",
        "for_patient": " für den Klienten \"{{name}}\"",
        "select_patient_first": "Bitte wählen Sie zuerst einen Klienten aus",
        "send_report_to_adapter": "Bericht an {{adapter}} senden",
        "cancel": "Abbrechen",
        "confirm": "Bestätigen",
        "audio_errors": {
            "access_denied": "Medendo konnte nicht auf die Audioquelle zugreifen",
            "invalid_source": "Die ausgewählte Quelle kann nicht als Audioeingabe verwendet werden. Bitte wählen Sie eine andere Quelle.",
            "no_mic_found": "Kein Mikrofon auf Ihrem Gerät gefunden. Bitte überprüfen Sie, ob Ihr Mikrofon angeschlossen ist, und versuchen Sie es erneut",
            "mic_fallback_to_default": "Ihr ausgewähltes Mikrofon wurde nicht gefunden. Stattdessen wird das Standardmikrofon verwendet. Wählen Sie bei Bedarf ein anderes.",
            "tab_capture_failed": "Für den ausgewählten Tab kann kein Audio aufgezeichnet werden. Möglicherweise haben Sie den falschen Tab ausgewählt (kein Audio-Track vorhanden), oder der Browser blockiert die Audioaufzeichnung des ausgewählten Tabs.",
            "mic_not_supported": "Dieser Browser erlaubt keinen Zugriff auf das Mikrofon, daher kann Medendo hier nicht aufnehmen. Bitte öffnen Sie Medendo in einem anderen Browser und versuchen Sie es erneut.",
            "start_recording_error": "Beim Starten der Aufnahme ist ein Fehler aufgetreten.",
            "upload_failed": "Fehler beim Hochladen des Audiofragments {{number}}",
            "low_audio_level": "Der Audiopegel ist schon eine Weile niedrig. Überprüfen Sie bitte Ihr Mikrofon.",
            "recording_not_capturing": "Seit einigen Minuten wurde nichts aufgezeichnet. Überprüfen Sie Ihr Mikrofon und starten Sie die Aufnahme neu.",
            "recording_stopped_early": "Ein Aufnahmefragment wurde früher als erwartet beendet. Überprüfen Sie die Transkription auf Lücken.",
            "audio_source_lost_microphone": "Das Mikrofon funktioniert nicht mehr. Medendo setzt die Aufnahme automatisch fort, sobald es wieder verbunden ist.",
            "audio_source_recovered_microphone": "Das Mikrofon ist wieder verbunden. Die Aufnahme wird automatisch fortgesetzt.",
            "audio_source_lost_screen": "Der geteilte Tab sendet kein Audio mehr. Teilen Sie den Tab erneut und starten Sie die Aufnahme neu.",
            "audio_source_interrupted_microphone": "Das Mikrofon wurde unterbrochen. Möglicherweise verwendet es eine andere App.",
            "audio_source_interrupted_screen": "Das Audio des geteilten Tabs wurde unterbrochen. Überprüfen Sie, ob der Tab noch abgespielt und geteilt wird.",
            "audio_source_added": "Ein neues Mikrofon wurde angeschlossen. Es wird für diese Aufnahme nicht verwendet. Beenden Sie die Aufnahme und starten Sie sie neu, um zu wechseln.",
            "recording_error": "Aufnahmefehler aufgetreten.",
            "start_recording_failed": "Aufnahme konnte nicht gestartet werden.",
            "session_start_failed": "Die Audioaufnahme-Sitzung konnte nicht gestartet werden. Überprüfen Sie Ihr Mikrofon und/oder aktualisieren Sie Ihren Browser.",
            "upload_missing": "Keine Datei hochgeladen.",
            "no_transcription": "Kein Transkript empfangen.",
            "transcription_failed": "Transkription fehlgeschlagen."
        },
        "copy_transcript_tooltip": "Transkripttext in die Zwischenablage kopieren",
        "copy_transcript": "Transkript kopieren",
        "modify_report_tooltip": "Damit können Sie Anpassungen am gesamten Bericht vornehmen",
        "modify_report": "Bericht ändern",
        "modify_item_tooltip": "Damit können Änderungen an diesem Berichtselement vorgenommen werden",
        "modify_item": "Element ändern",
        "copy_report_tooltip": "Berichtstext in die Zwischenablage kopieren",
        "copy_report": "Bericht kopieren",
        "regenerate_report": "Bericht neu generieren",
        "report_actions": "Berichtsaktionen",
        "transcript_actions": "Transkriptaktionen",
        "send_report": "Bericht senden",
        "submit_report": "Bericht an {{adapter}} senden",
        "confirm_edit": "Bearbeitung bestätigen",
        "delete": "Löschen",
        "select_date_tooltip": "Datum auswählen",
        "copy_error": "Fehler beim Kopieren",
        "autosave_saving": "Wird gespeichert…",
        "autosave_saved": "Gespeichert",
        "autosave_error": "Ihre Änderungen konnten nicht gespeichert werden",
        "send_report_tooltip": "Bericht senden",
        "send_needs_ehr_template": "Diese Vorlage ist nicht mit {{adapter}} verknüpft. Wählen Sie eine {{adapter}}-Vorlage, um den Bericht zu senden.",
        "report_submitted_message": "Bericht erfolgreich an {{adapter}} übermittelt",
        "recording_in_progress": "Aufnahme läuft. Das Transkript wird regelmäßig aktualisiert und zeigt, wer spricht.",
        "next_update_in": "Nächste Aktualisierung in",
        "transcribing_last_audio": "Letztes Audio wird transkribiert...",
        "participant": "Teilnehmer",
        "identifying": "Sprecher wird identifiziert",
        "not_identified": "Nicht identifizierter Teilnehmer",
        "ai_dialog_title": "Was kann ich für Sie anpassen?",
        "ai_dialog_placeholder": "Geben Sie hier ein, was Sie anpassen möchten...",
        "ai_dialog_input": "Anpassungsanweisung",
        "ai_dialog_start_recording": "Spracheingabe starten",
        "ai_dialog_stop_recording": "Spracheingabe stoppen",
        "mic_access_denied": "Mikrofonzugriff verweigert. Bitte überprüfen Sie Ihre Browsereinstellungen.",
        "transcription_error": "Beim Transkribieren des Audios ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "processing_transcription": "Verarbeitung...",
        "select_microphone": "Mikrofon auswählen",
        "microphone_label": "Mikrofon",
        "change_microphone_hint": "Beenden Sie die Aufnahme, um das Mikrofon zu wechseln.",
        "default_microphone": "Standard",
        "no_microphone_found": "Kein Mikrofon gefunden",
        "mic_permission": {
            "title": "Mikrofonzugriff blockiert",
            "instruction": "Der Mikrofonzugriff für diese Website ist blockiert. Führen Sie die folgenden Schritte aus, um ihn zu aktivieren:",
            "step1": "Klicken Sie auf das Schloss-Symbol links neben der Adressleiste.",
            "step2": "Wählen Sie \"Websiteeinstellungen\".",
            "step3": "Suchen Sie in der Liste nach \"Mikrofon\" und setzen Sie es auf \"Zulassen\".",
            "step4": "Laden Sie diese Seite neu, um die Einstellungen zu übernehmen.",
            "close": "Schließen"
        },
        "menu_groups": "Gruppen",
        "live_translation": {
            "title": "Live-Übersetzung",
            "live": "Live",
            "toggle": "Live übersetzen",
            "language_label_first": "Erste Sprache",
            "language_label_second": "Zweite Sprache",
            "start_recording": "Starten Sie eine Aufnahme, um live zu übersetzen.",
            "original": "Original",
            "translated": "Übersetzt",
            "error_refused": "Die Live-Übersetzung wurde abgelehnt. Möglicherweise ist sie bereits an anderer Stelle geöffnet; schließen Sie sie dort oder versuchen Sie es später erneut.",
            "error_unavailable": "Die Live-Übersetzung ist derzeit nicht verfügbar. Schalten Sie sie aus und wieder ein, um es erneut zu versuchen.",
            "error_microphone": "Die Live-Übersetzung kann das Mikrofon in diesem Browser nicht verwenden."
        }
    },
    "chat": {
        "title": "KI Chat",
        "collapse": "KI Chat ausblenden",
        "expand": "KI Chat einblenden",
        "expand_new_reply": "KI Chat einblenden, neue Antwort",
        "replying": "KI Chat antwortet",
        "assistant_title": "Assistent",
        "busy_try_again": "Einen Moment bitte. Ich bearbeite noch Ihre letzte Anfrage.",
        "copy_message": "Nachricht kopieren",
        "fullscreen": "Vollbild",
        "exit_fullscreen": "Vollbild beenden",
        "dropzone_hint": "Dateien hier ablegen zum Hochladen",
        "parsing_file": "Dateiinhalt wird analysiert...",
        "placeholder": "Stellen Sie der KI eine Frage...",
        "attach_file": "Datei anhängen",
        "send": "Senden",
        "disclaimer": "KI kann Fehler machen. Bitte beachten Sie unsere Nutzungsrichtlinien.",
        "action_create_report": "Bericht generieren",
        "action_modify_report": "Bericht ändern",
        "action_no_response": "Keine Antwort des Assistenten auf Ihre Anfrage",
        "action_create_report_running": "Bericht wird erstellt...",
        "action_create_report_done": "Bericht erstellt",
        "action_create_report_failed": "Bericht nicht erstellt",
        "action_modify_report_running": "Bericht wird aktualisiert...",
        "action_modify_report_done": "Bericht aktualisiert",
        "action_modify_report_failed": "Bericht nicht aktualisiert",
        "changed_sections": "Aktualisiert: {{sections}}",
        "changed_nothing": "Der Bericht kam unverändert zurück",
        "tool_other_running": "Using a tool...",
        "tool_other_done": "Used a tool",
        "tool_other_failed": "A tool failed",
        "tool_status_running": "läuft",
        "tool_status_done": "abgeschlossen",
        "tool_status_failed": "fehlgeschlagen",
        "change_detected": "Begegnung geändert"
    },
    "auth": {
        "where_is_code_title": "Wo ist mein Code?",
        "code_explain_1": "Zur Anmeldung benötigen Sie einen Code aus einer Authenticator-App. Dies ist eine App auf Ihrem Telefon, die einen zusätzlichen Sicherheitscode generiert.",
        "most_used_apps": "Die am häufigsten verwendeten Apps sind:",
        "google_authenticator": "Google Authenticator",
        "microsoft_authenticator": "Microsoft Authenticator",
        "find_code_in_app": "Suchen Sie eine dieser Apps auf Ihrem Telefon und öffnen Sie sie. Sie sehen eine Liste mit einem oder mehreren Konten. Suchen Sie nach einem Code mit dem Namen medendo.",
        "enter_code": "Geben Sie den Code neben medendo ein, um fortzufahren.",
        "no_code_contact": "Keinen Code gefunden? Bitte kontaktieren Sie unseren Support. Sie finden eine Chat-Schaltfläche in der unteren rechten Ecke. Klicken Sie darauf, um Kontakt aufzunehmen.",
        "sign_up_with_google": "Mit Google registrieren",
        "log_in_with_google": "Mit Google anmelden",
        "sign_up_with_microsoft": "Mit Microsoft registrieren",
        "log_in_with_microsoft": "Mit Microsoft anmelden",
        "signin_failed": "Eine Anmeldung mit dem ausgewählten Konto ist nicht möglich.",
        "no_account_found": "Kein Konto für diese E-Mail-Adresse gefunden. Registrieren Sie sich, um loszulegen.",
        "no_account_found_no_signup": "Kein Konto für diese E-Mail-Adresse gefunden.",
        "password_setup": {
            "title": "Neues Passwort wählen",
            "password_label": "Neues Passwort eingeben",
            "submit": "Passwort festlegen",
            "reset_failed": "Passwort konnte nicht zurückgesetzt werden.",
            "success_message": "Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
            "go_to_login": "Zur Anmeldeseite"
        }
    },
    "history": {
        "retention_hint_one": "Gelöscht {{count}} Tag nach der letzten Änderung",
        "retention_hint_other": "Gelöscht {{count}} Tage nach der letzten Änderung",
        "sort_label": "Sortieren",
        "sort_newest": "Neueste zuerst",
        "sort_oldest": "Älteste zuerst",
        "sort_expiring": "Bald ablaufende zuerst",
        "sort_name": "Name A-Z",
        "sort_template": "Vorlage A-Z",
        "sort_client": "Klient A-Z",
        "expires_in_one": "Läuft in {{count}} Tag ab",
        "expires_in_other": "Läuft in {{count}} Tagen ab",
        "no_client": "Kein Klient",
        "no_template": "Keine Vorlage",
        "record_count_one": "{{count}} Begegnung",
        "record_count_other": "{{count}} Begegnungen",
        "today": "Heute",
        "yesterday": "Gestern",
        "expires_today": "Läuft heute ab",
        "expires_tomorrow": "Läuft morgen ab",
        "search_placeholder": "Suchen...",
        "no_results": "Keine Begegnungen entsprechen Ihrer Suche",
        "empty": "Noch keine Begegnungen",
        "column_patient": "Klient",
        "column_template": "Vorlage",
        "column_date": "Datum",
        "column_available_until": "Verfügbar bis",
        "fetch_error": "Beim Abrufen des Verlaufs ist ein Fehler aufgetreten.",
        "delete_confirm_title": "Begegnung löschen?",
        "delete_confirm": "Dies kann nicht rückgängig gemacht werden.",
        "delete": "Löschen",
        "cancel": "Abbrechen",
        "delete_error": "Beim Löschen der Begegnung ist ein Fehler aufgetreten.",
        "actions_tooltip": "Begegnungsaktionen",
        "offboarded_notice": "Ihr Konto ist inaktiv, Sie können also keine neuen Aufnahmen machen. Die Berichte und Transkripte, die noch nicht abgelaufen sind, können Sie weiterhin lesen. Schauen Sie bei 'Verfügbar bis'.",
        "renew_hint": "Wollen Sie wieder aufnehmen? Gehen Sie zu Einstellungen, um Ihr Abo zu verlängern."
    },
    "admin": {
        "user_added_success": "Benutzer erfolgreich hinzugefügt.",
        "add_invalid_input": "E-Mail-Adresse oder Name ist ungültig.",
        "user_exists": "Benutzer existiert bereits.",
        "add_failed": "Benutzer konnte nicht hinzugefügt werden.",
        "user_updated_success": "Benutzer erfolgreich aktualisiert.",
        "user_update_failed": "Benutzer konnte nicht aktualisiert werden.",
        "column_email": "E-Mail",
        "column_permissions": "Berechtigungen",
        "column_status": "Status",
        "select_all_on_page": "Alle auf dieser Seite auswählen",
        "previous_page": "Zurück",
        "next_page": "Weiter",
        "page_of": "Seite {{page}} von {{total}}",
        "add_user_title": "Benutzer hinzufügen",
        "email_label": "E-Mail-Adresse",
        "given_name_label": "Vorname",
        "family_name_label": "Nachname",
        "cancel": "Abbrechen",
        "add": "Hinzufügen",
        "domain_mismatch_warning": "Warnung: Die Domain dieser E-Mail-Adresse weicht von Ihrer Domain ({{domain}}) ab.",
        "invalid_email_error": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        "user_already_exists_error": "Dieser Benutzer existiert bereits",
        "status_filter": "Status",
        "permission_filter": "Berechtigung",
        "all": "Alle",
        "status_active": "Aktiv",
        "status_inactive": "Inaktiv",
        "can_record": "Aufnahme",
        "can_template": "Vorlagen",
        "can_admin_templates": "Vorlagen-Admin",
        "batch_onboard_btn": "Benutzer anlegen",
        "batch_offboard_btn": "Benutzer deaktivieren",
        "n_selected": "{{count}} ausgewählt",
        "delete_tooltip": "Entfernen",
        "clear_selection_tooltip": "Auswahl aufheben",
        "batch_status_success": "Status von {{count}} Benutzern auf {{status}} geändert.",
        "batch_status_error": "Fehler beim Ändern des Status.",
        "batch_status_partial": "Nicht alle Benutzer konnten aktualisiert werden.",
        "file_too_large_admin": "Datei ist zu groß. Maximale Größe beträgt 1 MB.",
        "file_process_error": "Fehler bei der Dateiverarbeitung. Bitte versuchen Sie es erneut.",
        "batch_onboard": "Stapel anlegen",
        "batch_offboard": "Stapel deaktivieren",
        "batch_operation": "Stapelvorgang",
        "processing_file": "Datei wird verarbeitet... Dies kann einen Moment dauern.",
        "close": "Schließen",
        "no_users_in_file": "Keine Benutzer in der Datei gefunden.",
        "success_count": "Erfolgreich: {{count}}",
        "failed_count": "Fehlgeschlagen: {{count}}",
        "confirm_n": "Bestätigen ({{count}})",
        "retry_failed_n": "Fehlgeschlagene wiederholen ({{count}})",
        "batch_delete_title": "Entfernen bestätigen",
        "batch_delete_content": "Sie sind dabei, <strong>{{count}}</strong> {{userText}} zu entfernen. Diese werden keinen Zugriff mehr auf Medendo haben. Sind Sie sicher, dass Sie sie entfernen möchten?",
        "batch_delete_user": "Benutzer",
        "batch_delete_users": "Benutzer",
        "batch_delete_confirm": "Entfernen",
        "fetch_error": "Fehler beim Abrufen der Benutzer.",
        "permissions_updated_success": "Berechtigungen erfolgreich aktualisiert.",
        "permissions_update_error": "Fehler beim Aktualisieren der Berechtigungen.",
        "user_deactivated_success": "Benutzerstatus auf INAKTIV gesetzt.",
        "user_activated_success": "Benutzer auf AKTIV zurückgesetzt.",
        "user_restore_error": "Fehler beim Wiederherstellen des Benutzers.",
        "no_users_selected": "Keine Benutzer ausgewählt.",
        "user_not_found": "Benutzer nicht gefunden.",
        "unknown_error": "Unbekannter Fehler.",
        "batch_delete_success": "{{count}} Benutzer entfernt.",
        "batch_delete_error": "Fehler beim Entfernen der Benutzer.",
        "batch_delete_partial": "Nicht alle ausgewählten Benutzer konnten entfernt werden.",
        "batch_permissions_success": "{{count}} Benutzer aktualisiert.",
        "batch_permissions_error": "Fehler beim Aktualisieren der Berechtigungen.",
        "batch_permissions_partial": "Nicht alle Benutzer konnten aktualisiert werden.",
        "status_update_error": "Fehler beim Aktualisieren des Benutzerstatus.",
        "status_active_label": "AKTIV",
        "status_inactive_label": "INAKTIV",
        "batch_onboard_server_error": "Beim Hinzufügen des Benutzers ist ein Fehler aufgetreten.",
        "can_org_admin": "Administrator"
    },
    "settings": {
        "title": "Einstellungen",
        "language_label": "Sprache",
        "locale_update_error": "Sprache konnte nicht aktualisiert werden.",
        "preferences_title": "Präferenzen",
        "sounds_label": "Soundeffekte",
        "analytics_api_key": {
            "title": "Analytics-API-Schlüssel",
            "info": "Verwenden Sie diesen Schlüssel zur Authentifizierung bei der Medendo-Nutzungsanalyse-API. Der vollständige Wert wird nur einmal angezeigt, wenn der Schlüssel erstmalig erstellt oder unmittelbar nach einer Rotation angezeigt wird. Durch eine Rotation wird der aktuelle Schlüssel durch einen neuen ersetzt. Der vorherige Schlüssel wird deaktiviert.",
            "active_label": "Aktiver Schlüssel",
            "rotate": "Rotieren",
            "store_warning": "Speichern Sie diesen Schlüssel jetzt. Er wird nicht erneut angezeigt.",
            "copy": "Kopieren",
            "copied": "Analytics-API-Schlüssel in die Zwischenablage kopiert.",
            "copy_failed": "Analytics-API-Schlüssel konnte nicht kopiert werden.",
            "load_failed": "Status des Analytics-API-Schlüssels konnte nicht geladen werden.",
            "action_failed": "Aktion für Analytics-API-Schlüssel fehlgeschlagen.",
            "missing_error": "Für Ihre Organisation ist kein Analytics-API-Schlüssel konfiguriert. Bitte kontaktieren Sie den Support."
        },
        "your_groups": "Ihre Gruppen",
        "your_groups_empty": "Sie sind noch kein Mitglied einer Gruppe.",
        "account_title": "Konto",
        "status_label": "Status",
        "status_inactive": "Inaktiv",
        "renew_explanation": "Ihr Abo ist beendet, Sie können also nur lesen, was Sie bereits aufgenommen haben. Verlängern Sie es, um wieder aufzunehmen.",
        "renew_button": "Abo verlängern",
        "renew_error": "Beim Starten Ihrer Verlängerung ist etwas schiefgelaufen. Bitte versuchen Sie es erneut."
    },
    "offboard": {
        "title": "Benutzer deaktivieren",
        "question": "Möchten Sie diesen Benutzer wirklich deaktivieren?",
        "cancel": "Abbrechen",
        "confirm": "Bestätigen",
        "deleting": "Wird deaktiviert..."
    },
    "templates": {
        "sort_favorites": "Favoriten zuerst",
        "sort_name": "Name A-Z",
        "sort_recent": "Zuletzt geändert",
        "sort_author": "Autor A-Z",
        "group_favorites": "Favoriten",
        "group_all": "Alle Vorlagen",
        "template_count_one": "{{count}} Vorlage",
        "template_count_other": "{{count}} Vorlagen",
        "new": "Neu",
        "list_label": "Vorlagen",
        "search_placeholder": "Suchen...",
        "sort_label": "Sortieren",
        "share_header": "Teilen",
        "description_header": "Beschreibung",
        "owner_header": "Eigentümer",
        "favorite_tooltip": "Als Favorit markierte Vorlagen werden bei der Auswahl einer Vorlage für eine Aufnahme zuerst angezeigt.",
        "shared_with_org": "Mit Organisation geteilt",
        "not_shared": "Nicht geteilt",
        "manager": {
            "copy_suffix": " (Kopie)",
            "imported_suffix": " (importiert)",
            "default_imported_name": "Importierte Vorlage"
        },
        "copy_tooltip": "Kopieren",
        "download_tooltip": "Herunterladen",
        "edit_tooltip": "Bearbeiten",
        "delete_tooltip": "Löschen",
        "delete_confirm_button": "Löschen",
        "delete_confirm_title": "Vorlage löschen?",
        "delete_confirm": "Dies kann nicht rückgängig gemacht werden.",
        "cancel": "Abbrechen",
        "read_file_error": "Dateiinhalt kann nicht gelesen werden.",
        "import_success": "Vorlage erfolgreich importiert.",
        "import_invalid": "Fehler beim Importieren der Vorlage. Handelt es sich um eine gültige JSON-Datei?",
        "create_dialog": {
            "title": "Wählen Sie eine Methode zum Erstellen einer Vorlage",
            "wizard": "Vorlagen-Assistent",
            "import": "Importieren",
            "library": "Bibliothek",
            "manual": "Manuell",
            "library_description": "Wählen Sie beliebig viele Vorlagen aus unserer Bibliothek als Ausgangspunkt.<br/><br/>Sie können mit diesen Vorlagen experimentieren, um die Funktionsweise des Medendo-Arbeitsbereichs kennenzulernen, und sie dann einfach an Ihre spezifischen Bedürfnisse und Interessen anpassen.",
            "library_button": "Aus Bibliothek wählen",
            "wizard_description": "Laden Sie einen ausgefüllten Musterbericht hoch, wie Sie ihn nach einem Gespräch mit einem Klienten selbst erstellen würden. Unterstützte Dateien: .docx, .pdf, .txt.<br/><br/>Die KI wandelt diesen in eine Vorlage um, die Sie in Medendo verwenden können. Achten Sie auf Anonymität.",
            "wizard_button": "Beispiel hochladen",
            "import_description": "Importieren Sie eine vorhandene Vorlage aus einer .json-Datei.",
            "import_button": ".json hochladen",
            "manual_description": "Sie können auch mit einer leeren Vorlage beginnen.<br/><br/>Wählen Sie diese Option, wenn Sie kein geeignetes Beispieldokument haben oder keine KI verwenden möchten.",
            "manual_button": "Selbst erstellen",
            "cancel": "Abbrechen"
        },
        "library": {
            "back": "Zurück",
            "title": "Vorlagenbibliothek",
            "description": "Diese Bibliothek ist eine Sammlung gängiger Vorlagen aus verschiedenen Gesundheitsdisziplinen. Wenn Sie eine Vorlage sehen, die Sie verwenden möchten, können Sie auf die Schaltfläche \"Hinzufügen\" klicken, um sie in Ihrem Konto verfügbar zu machen. Sobald die Vorlage in Ihrem Konto ist, können Sie sie auch frei bearbeiten.",
            "tabs": {
                "external": "Extern"
            },
            "search_placeholder": "In Bibliothek suchen...",
            "locale_filter_all": "Alle Sprachen",
            "language_label": "Sprache",
            "table": {
                "template": "Vorlage",
                "description": "Beschreibung",
                "actions": "Aktionen"
            },
            "actions": {
                "add": "Hinzufügen",
                "add_tooltip": "Diese Vorlage zu Ihrer Sammlung hinzufügen",
                "in_templates": "In Ihren Vorlagen",
                "import_success": "Vorlage \"{{name}}\" erfolgreich hinzugefügt.",
                "import_error": "Beim Importieren der Vorlage ist ein Fehler aufgetreten",
                "fetch_error": "Beim Abrufen der Vorlagenbibliothek ist ein Fehler aufgetreten."
            }
        },
        "external_library": {
            "search_placeholder": "In {{adapter}}-Bibliothek suchen...",
            "search_placeholder_default": "Adapter",
            "table": {
                "template": "Vorlage",
                "description": "Beschreibung",
                "actions": "Aktionen"
            },
            "actions": {
                "add": "Hinzufügen",
                "add_tooltip": "Diese Vorlage zu Ihrer Sammlung hinzufügen",
                "in_templates": "In Ihren Vorlagen",
                "import_success": "Vorlage \"{{name}}\" erfolgreich hinzugefügt.",
                "import_error": "Beim Importieren der Vorlage ist ein Fehler aufgetreten"
            }
        },
        "view": {
            "back": "Zurück",
            "download": "Herunterladen",
            "edit": "Bearbeiten",
            "name": "Name:",
            "description": "Beschreibung:",
            "no_description": "Keine Beschreibung verfügbar",
            "items": "Elemente:",
            "no_description_fallback": "Keine Beschreibung",
            "no_examples_fallback": "Keine Beispiele"
        },
        "edit": {
            "back": "Zurück",
            "sync": "Mit EHR synchronisieren",
            "save": "Speichern",
            "name_label": "Name",
            "description_label": "Beschreibung",
            "keywords_label": "Schlüsselwörter",
            "keywords_info": "Fügen Sie medizinische Begriffe, Namen oder Fachjargon hinzu, die schwer zu transkribieren sind. Diese werden an die Spracherkennung übergeben, um die Erkennungsgenauigkeit für diese Vorlage zu verbessern.",
            "keywords_placeholder": "z. B. Quetiapin, Sertralin, Methylphenidat: durch Leerzeichen, Kommas, Punkte oder Zeilenumbrüche trennen",
            "items_header": "Elemente:",
            "add_item": "Neues Element hinzufügen",
            "item_name": "Name",
            "item_type": "Typ",
            "item_default_value": "Standardtext",
            "note_hint": "Dieser Text erscheint unverändert im Bericht. Die KI wird ihn nicht verändern.",
            "item_description": "Beschreibung",
            "item_examples": "Beispiele",
            "delete_item_tooltip": "Element löschen",
            "copy_item_tooltip": "Element kopieren",
            "move_up_tooltip": "Nach oben verschieben",
            "move_down_tooltip": "Nach unten verschieben",
            "copy_suffix": " (Kopie)",
            "sync_success": "{{count}} neue Elemente hinzugefügt",
            "sync_updated": "Vorlage synchronisiert",
            "sync_updated_with_items": "Vorlage synchronisiert, {{count}} neue Elemente hinzugefügt",
            "sync_up_to_date": "Vorlage ist bereits aktuell",
            "sync_error": "Fehler beim Synchronisieren der Vorlage.",
            "magic_wand": "Vorlage ändern",
            "magic_wand_tooltip": "Beschreiben Sie, was Sie ändern möchten, und die KI passt die Vorlage an",
            "modifying_ai": "Die KI passt die Vorlage an …",
            "modify_success": "Die KI hat die Vorlage angepasst",
            "modify_error": "Fehler beim Ändern der Vorlage.",
            "save_error_no_name": "Bitte geben Sie einen Namen für die Vorlage an.",
            "save_error_no_items": "Bitte fügen Sie mindestens ein Element hinzu.",
            "save_success_updated": "Vorlage erfolgreich aktualisiert",
            "save_success_created": "Vorlage erfolgreich erstellt",
            "save_error_generic": "Fehler beim Speichern der Vorlage.",
            "default_description": "Ein chronologischer Bericht des Gesprächs mit dem Klienten, Patienten und/oder anderen Personen in narrativer Form.",
            "types": {
                "text": "Text",
                "number": "Zahl",
                "date": "Datum",
                "checkbox": "Kontrollkästchen",
                "radiobutton": "Optionsschaltfläche",
                "checkbox_group": "Kontrollkästchengruppe",
                "note": "Notiz"
            },
            "options_label": "Optionen",
            "add_option": "Option hinzufügen",
            "option_placeholder": "Option",
            "duplicate_option": "Diese Option existiert bereits"
        },
        "share_dialog": {
            "title": "Vorlage teilen?",
            "content": "Möchten Sie \"{{templateName}}\" wirklich mit der Gruppe \"{{groupName}}\" teilen?",
            "cancel": "Abbrechen",
            "confirm": "Teilen"
        },
        "unshare_dialog": {
            "title": "Freigabe beenden?",
            "content": "Möchten Sie die Freigabe von \"{{templateName}}\" für die Gruppe \"{{groupName}}\" wirklich beenden?",
            "cancel": "Abbrechen",
            "confirm": "Freigabe beenden"
        },
        "wizard_loading": {
            "elapsed_time": "Verstrichene Zeit: {{time}}",
            "please_wait": "Bitte haben Sie einen Moment Geduld...",
            "messages": [
                "Datei wird hochgeladen ...",
                "Dokument wird gelesen ...",
                "Inhalt wird analysiert ...",
                "Vorlage wird generiert ...",
                "Fast fertig ..."
            ]
        },
        "created_by": "Erstellt von {{creator}}",
        "modified_ago": "geändert {{time}}",
        "created_modified_tooltip": "Erstellt {{created}} · zuletzt geändert {{modified}}",
        "created_date": "Erstellt {{date}}",
        "author_header": "Autor",
        "shared_with_header": "Geteilt mit",
        "modified_header": "Geändert",
        "author_you": "Sie",
        "admins_only": "nur Admins",
        "no_results": "Keine Vorlagen entsprechen Ihrer Suche.",
        "n_groups": "{{count}} Gruppen",
        "actions_tooltip": "Vorlagenaktionen",
        "share_manage": {
            "title": "Freigabe verwalten",
            "not_shared": "Nicht freigegeben",
            "all_members": "Alle Mitglieder",
            "admins_only": "Nur Admins",
            "no_rights": "Sie haben in keiner Gruppe Freigaberechte. Admins und Vorlagen-Admins können Vorlagen teilen.",
            "private_summary": "Diese Vorlage ist nur für Sie sichtbar.",
            "shared_summary_one": "Mit {{count}} Gruppe geteilt.",
            "shared_summary_other": "Mit {{count}} Gruppen geteilt.",
            "cancel": "Abbrechen",
            "save": "Speichern"
        }
    },
    "adapter": {
        "connection_error": "{{adapter}} ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
        "reconnected": "Erfolgreich mit {{adapter}} wieder verbunden.",
        "reconnect_required": "Ihre {{adapter}}-Sitzung ist abgelaufen. Bitte verbinden Sie sich erneut.",
        "reconnect_failed": "Verbindung mit {{adapter}} konnte nicht wiederhergestellt werden. Bitte verbinden Sie sich über Integrationen erneut.",
        "fetch_templates_error": "Vorlagen konnten nicht von {{adapter}} geladen werden.",
        "fetch_patients_error": "Klienten konnten nicht von {{adapter}} geladen werden.",
        "required_fields_one": "Das Feld {{fields}} ist ein Pflichtfeld und muss ausgefüllt werden.",
        "required_fields_other": "Die Felder {{fields}} sind Pflichtfelder und müssen ausgefüllt werden."
    },
    "integrations": {
        "load_error": "Integrationen konnten nicht geladen werden",
        "init_error": "Verbindung konnte nicht gestartet werden",
        "launch": {
            "session_expired": "Sitzung abgelaufen. Bitte öffnen Sie Medendo erneut aus Ihrem KIS.",
            "config_error": "KIS-Sitzung konnte nicht hergestellt werden. Bitte kontaktieren Sie den Support."
        },
        "disconnect_confirm_title": "Verbindung mit {{adapter}} trennen?",
        "disconnect_confirm": "Sie können sich jederzeit erneut verbinden.",
        "cancel": "Abbrechen",
        "disconnect_success": "Verbindung getrennt",
        "disconnect_error": "Verbindung konnte nicht getrennt werden",
        "connected": "Verbunden",
        "not_connected": "Nicht verbunden",
        "disconnect_btn": "Trennen",
        "connect_btn": "Verbinden",
        "callback": {
            "invalid_parameters": "Ungültige Callback-Parameter",
            "success": "Integration erfolgreich verbunden!",
            "error": "Integration konnte nicht abgeschlossen werden",
            "redirecting": "Sie werden zur Integrationsseite weitergeleitet...",
            "connecting": "Integration wird verbunden...",
            "please_wait": "Bitte warten Sie, während Ihre Integration konfiguriert wird."
        }
    },
    "errors": {
        "create_encounter": "Beim Erstellen der Begegnung ist ein Fehler aufgetreten.",
        "update_encounter": "Beim Aktualisieren der Begegnung ist ein Fehler aufgetreten.",
        "client_locked": "Der Klient kann nicht mehr geändert werden: Der Assistent hat seine Vorgeschichte bereits abgerufen.",
        "generate_report": "Beim Generieren des Berichts ist ein Fehler aufgetreten.",
        "generate_transcript": "Beim Generieren des Transkripts ist ein Fehler aufgetreten.",
        "update_field": "Beim Aktualisieren des Feldes ist ein Fehler aufgetreten.",
        "upload_file": "Beim Hochladen der Datei ist ein Fehler aufgetreten.",
        "delete_file": "Beim Löschen der Datei ist ein Fehler aufgetreten.",
        "send_message": "Beim Senden der Nachricht ist ein Fehler aufgetreten.",
        "submit_report": "Beim Übermitteln des Berichts ist ein Fehler aufgetreten.",
        "fetch_templates": "Beim Abrufen der Vorlagen ist ein Fehler aufgetreten.",
        "fetch_groups": "Beim Abrufen der Gruppen ist ein Fehler aufgetreten.",
        "copy_template": "Beim Kopieren der Vorlage ist ein Fehler aufgetreten.",
        "share_template": "Beim Teilen der Vorlage ist ein Fehler aufgetreten.",
        "unshare_template": "Beim Aufheben der Freigabe der Vorlage ist ein Fehler aufgetreten.",
        "delete_template": "Beim Löschen der Vorlage ist ein Fehler aufgetreten.",
        "logout": "Beim Abmelden ist ein Fehler aufgetreten.",
        "user_info": "Beim Abrufen der Benutzerinformationen ist ein Fehler aufgetreten.",
        "not_found_encounter": "Begegnung konnte nicht gefunden werden.",
        "azure_policy_violation": "Änderung aufgrund der Azure OpenAI-Inhaltsrichtlinie fehlgeschlagen. Bitte versuchen Sie es erneut. Falls es erneut fehlschlägt, kontaktieren Sie den Support.",
        "restricted_browser_environment": "Es sieht aus, als hätten Sie unsere App in einer eingeschränkten Browserumgebung geöffnet. Bitte öffnen Sie die App in Ihrem Browser.",
        "item_missing_in_template": "Das ausgewählte Element fehlt in der Vorlage und kann nicht geändert werden (die Vorlage wurde möglicherweise geändert).",
        "file_too_large": "Datei \"{{name}}\" ist zu groß. Sie darf {{maxMb}} MB nicht überschreiten.",
        "upload_success": "Datei \"{{name}}\" erfolgreich hochgeladen.",
        "process_file_problem": "Bei der Verarbeitung von \"{{name}}\" ist ein Problem aufgetreten.",
        "template_not_found": "Die angeforderte Vorlage ({{id}}) steht Ihnen nicht zur Verfügung. Wenden Sie sich an die Person, die für die Verbindung mit dem Medendo-System zuständig ist.",
        "patient_not_found": "Der Klient aus dem Aufruf ({{id}}) steht Ihnen nicht zur Verfügung. Wenden Sie sich an die Person, die für die Verbindung mit dem Medendo-System zuständig ist.",
        "update_favorite_failed": "Favoritenstatus konnte nicht aktualisiert werden.",
        "template_shared": "Vorlage \"{{name}}\" erfolgreich geteilt.",
        "template_unshared": "Freigabe der Vorlage \"{{name}}\" wurde aufgehoben.",
        "template_deleted": "Vorlage erfolgreich gelöscht.",
        "copy_success": "Vorlage erfolgreich kopiert.",
        "file_deleted_success": "Datei \"{{name}}\" erfolgreich gelöscht.",
        "process_file_delete_problem": "Beim Löschen von \"{{name}}\" ist ein Problem aufgetreten.",
        "unauthorized_refresh": "Nicht autorisierte Anfrage. Token-Aktualisierung wird versucht...",
        "error_page": {
            "title": "Hoppla! Etwas ist schiefgelaufen.",
            "default_message": "Die gesuchte Seite wurde nicht gefunden oder es ist ein anderer Fehler aufgetreten.",
            "unexpected_message": "Ein unerwarteter Fehler ist aufgetreten. Gehen Sie zurück zur Startseite und versuchen Sie es erneut.",
            "back_home": "Zurück zur Startseite"
        },
        "sharing_updated": "Freigabe aktualisiert.",
        "update_sharing": "Beim Aktualisieren der Freigabe ist ein Fehler aufgetreten."
    },
    "privacy_policy": {
        "title": "Medendo Datenschutzerklärung",
        "agree_checkbox": "Ich stimme der Datenschutzerklärung zu",
        "agree_button": "Zustimmen"
    },
    "usage_instructions": {
        "title": "Anweisungen zur verantwortungsvollen Nutzung von Medendo",
        "agree_checkbox": "Ich habe die allgemeinen Anweisungen gelesen und verstanden",
        "agree_button": "Zustimmen"
    },
    "user_agreement": {
        "title": "Allgemeine Geschäftsbedingungen für die Nutzung von Medendo",
        "agree_checkbox": "Ich stimme den Allgemeinen Geschäftsbedingungen zu",
        "agree_button": "Zustimmen"
    },
    "groups": {
        "title": "Gruppen",
        "create_title": "Gruppe erstellen",
        "name_label": "Gruppenname",
        "description_label": "Beschreibung (optional)",
        "create_admin_note": "Sie werden der erste Administrator der Gruppe. Fügen Sie Mitglieder hinzu und teilen Sie Vorlagen, sobald sie erstellt ist.",
        "create": "Erstellen",
        "cancel": "Abbrechen",
        "create_error": "Beim Erstellen der Gruppe ist ein Fehler aufgetreten.",
        "created": "Gruppe \"{{name}}\" erstellt.",
        "no_groups": "Keine Gruppen verfügbar.",
        "no_users_found": "Keine Benutzer gefunden.",
        "search_more_hint": "Es werden die ersten {{count}} Ergebnisse angezeigt. Verfeinern Sie Ihre Suche, um mehr zu sehen.",
        "tab_templates": "Vorlagen",
        "template_visibility_group": "Alle Mitglieder",
        "template_visibility_admin": "Gruppenadministratoren",
        "template_visibility_private": "Privat",
        "no_templates": "Noch keine Vorlagen mit dieser Gruppe geteilt.",
        "description": "Teams in Ihrer Organisation, die Vorlagen teilen.",
        "search_placeholder": "Gruppen suchen…",
        "search_members_placeholder": "Mitglieder suchen…",
        "all_groups": "Alle Gruppen",
        "new_group": "Neue Gruppe",
        "scope_group_admins_hint": "Nur für Gruppenadministratoren sichtbar.",
        "view_only_hint": "Sie können die Mitglieder dieser Gruppe einsehen. Die Bearbeitung ist auf Gruppen- und Organisationsadministratoren beschränkt.",
        "member_role_admin": "Administrator",
        "member_role_member": "Mitglied",
        "add_member": "Mitglied hinzufügen",
        "add_member_title": "Mitglied hinzufügen",
        "add_member_search_label": "Benutzer suchen",
        "add": "Hinzufügen",
        "no_members": "Keine Mitglieder in dieser Gruppe.",
        "fetch_members_error": "Beim Abrufen der Mitglieder ist ein Fehler aufgetreten.",
        "add_member_error": "Beim Hinzufügen des Mitglieds ist ein Fehler aufgetreten.",
        "remove_member_error": "Beim Entfernen des Mitglieds ist ein Fehler aufgetreten.",
        "update_member_error": "Beim Aktualisieren des Mitglieds ist ein Fehler aufgetreten.",
        "member_added": "Mitglied hinzugefügt.",
        "member_removed": "Mitglied entfernt.",
        "member_updated": "Mitgliederberechtigungen aktualisiert.",
        "scope_change_tooltip": "Sichtbarkeit ändern",
        "open_template_tooltip": "Vorlage öffnen",
        "integration_tooltip": "Gehört zur {{name}}-Integration",
        "member_actions_tooltip": "Mitgliederaktionen",
        "remove_from_group": "Aus Gruppe entfernen",
        "deleted": "Gruppe gelöscht.",
        "delete_error": "Beim Löschen der Gruppe ist ein Fehler aufgetreten.",
        "edit_title": "Gruppe bearbeiten",
        "save_changes": "Änderungen speichern",
        "edit_hint": "Mitglieder und Vorlagen sind nicht betroffen: nur das Erscheinungsbild der Gruppe.",
        "updated": "Gruppendetails aktualisiert.",
        "update_error": "Beim Aktualisieren der Gruppe ist ein Fehler aufgetreten.",
        "add_member_note": "Neue Mitglieder werden als Mitglied hinzugefügt. Nur ein Organisationsadministrator kann jemanden zum Gruppenadministrator machen.",
        "member_you": "Sie",
        "delete_dialog_title": "Gruppe '{{name}}' löschen?",
        "delete_body": "Zugewiesene Templates werden für ihre Eigentümer privat. Dies kann nicht rückgängig gemacht werden.",
        "delete_affected_one": "1 geteilte Vorlage und {{memberCount}} Mitgliedschaften sind betroffen.",
        "delete_affected_other": "{{count}} geteilte Vorlagen und {{memberCount}} Mitgliedschaften sind betroffen.",
        "delete_confirm_button": "Gruppe löschen",
        "n_shared_one": "1 geteilte Vorlage",
        "n_shared_other": "{{count}} geteilte Vorlagen",
        "private_templates_section": "Ihre privaten Vorlagen",
        "members_section_title": "Mitglieder",
        "edit_action": "Bearbeiten",
        "n_members_one": "1 Mitglied",
        "n_members_other": "{{count}} Mitglieder",
        "n_admins_one": "1 Administrator",
        "n_admins_other": "{{count}} Administratoren",
        "n_template_admins_one": "1 Vorlagen-Admin",
        "n_template_admins_other": "{{count}} Vorlagen-Admins",
        "role_template_admin": "Vorlagen-Admin",
        "make_admin": "Zum Administrator machen",
        "make_template_admin": "Zum Vorlagen-Admin machen",
        "make_member": "Rolle auf Mitglied setzen",
        "set_role_admin_title": "Zum Administrator machen?",
        "set_role_admin_body": "Die Person kann Mitglieder hinzufügen oder entfernen, Rollen festlegen und die Vorlagenfreigabe dieser Gruppe verwalten.",
        "set_role_admin_confirm": "Zum Administrator machen",
        "set_role_template_admin_title": "Zum Vorlagen-Admin machen?",
        "set_role_template_admin_body": "Die Person kann zusätzlich zur normalen Mitgliedschaft Vorlagen mit dieser Gruppe teilen und die Freigabe aufheben.",
        "set_role_template_admin_confirm": "Zum Vorlagen-Admin machen",
        "set_role_member_title": "Als Mitglied festlegen?",
        "set_role_member_body": "Die Person behält ihre Mitgliedschaft, kann aber nur die Gruppe und ihre geteilten Vorlagen ansehen.",
        "set_role_member_confirm": "Als Mitglied festlegen",
        "no_matches": "Keine Übereinstimmungen",
        "no_results": "Keine Ergebnisse"
    }
}
